import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Feather, Lock } from "lucide-react";
import { auth, formatApiError } from "@/lib/api";
import { useAuth } from "@/auth/AuthContext";

export default function AdminLogin() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    async function submit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const u = await auth.login(email.trim().toLowerCase(), password);
            setUser(u);
            toast.success("Willkommen, " + (u.name || "Admin"));
            navigate("/admin");
        } catch (err) {
            toast.error(formatApiError(err?.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen night-sky flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <Link to="/" className="inline-flex items-center gap-3 mb-12">
                    <Feather size={20} className="text-[#f0c674]" strokeWidth={1.5} />
                    <span className="font-display text-2xl">Taubenwacht</span>
                </Link>
                <div className="glass p-8">
                    <div className="flex items-center gap-3 mb-6">
                        <Lock size={20} className="text-[#f0c674]" strokeWidth={1.3} />
                        <h1 className="font-display text-3xl">Admin-Bereich</h1>
                    </div>
                    <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="admin@taubenhimmel.de"
                            className="input-field"
                            required
                            autoComplete="email"
                            data-testid="admin-email"
                        />
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Passwort"
                            className="input-field"
                            required
                            autoComplete="current-password"
                            data-testid="admin-password"
                        />
                        <button type="submit" className="btn-primary w-full justify-center" disabled={loading} data-testid="admin-submit">
                            {loading ? "Anmelden…" : "Anmelden"}
                        </button>
                    </form>
                </div>
                <Link to="/" className="block text-center text-[#64748b] text-sm mt-8 hover:text-[#f0c674]">
                    ← Zur Startseite
                </Link>
            </div>
        </div>
    );
}
